import React from 'react';

const AboutHeader = () => {
  return (
    <section className="pt-24 pb-16 bg-gradient-to-r from-blue-600 to-cyan-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center" data-aos="zoom-in">
          <h1 className="text-5xl font-bold mb-6">About Our Unique Visa Services</h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
            Your trusted partner in All Europe Countries immigration for over a decade. Transforming dreams into reality with expertise, integrity, and personalized care.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutHeader;